const FieldGatewayStatus = {
  UNDEFINED: "undefined",
  NOT_FOUND: "not_found",
  ONLINE: "online",
  CONFIGURATION_ERROR: "configuration_error",
};

export default FieldGatewayStatus;
